export default __webpack_public_path__ + "static/media/lydia kou.9a2df4ec.jpg";